// extracted by mini-css-extract-plugin
module.exports =  {"selectedIcon":"style-module_selectedIcon__oejubksAT44hk016ootA"};